module.exports = __webpack_public_path__ + "img/620.2dbed7e4.jpg";